import { CurrentUserContext, UserPermissionContext } from '../../server-middleware/userContext'
import Configurator, { isThemeType, ThemeTypes } from '../theme-configuration/configurator'
import { parse } from 'qs'
import CustomizationToolbar, { pageOptions } from '@insided/destination/modules/Customization/configurator/toolbar'
import Portal from 'preact-portal'
import TranslationForm from '../../components/translation-form/TranslationForm'
import classNames from 'classnames'
import { ServerGenericPageWidget } from '@insided/customization'

interface Props {
  controlUrl: string
  elements: ServerGenericPageWidget[]
}

function getEnabledTheme(): ThemeTypes {
  if (typeof window === 'undefined') {
    return null
  }
  const theme = parse(window.location.search, { ignoreQueryPrefix: true }).theme

  if (typeof theme === 'string' && isThemeType(theme)) {
    return theme
  }
  return null
}

function getWidgetConfigurationPage(): pageOptions | null {
  if (typeof window === 'undefined') {
    return null
  }

  const path = window.location.pathname
  if (path === '/') return 'homepage'
  if (path === '/ideas') return 'ideation'
  if (path === '/product-updates') return 'productUpdates'
  if (path === '/knowledge-base') return 'knowledgeBase'
  if (path === '/community') return 'community'
  if (path === '/site/communityOverviewV2') return 'community'

  return null
}

function isCustomizing() {
  return typeof window !== 'undefined' && window.location.search.includes('customize')
}

function AdminToolbar({ controlUrl, elements }: Props) {
  const customizationPage = getWidgetConfigurationPage()

  return (
    <CurrentUserContext.Consumer>
      {(user) => {
        if (!user.id) return null

        return (
          <UserPermissionContext.Consumer>
            {(permissionsContext) => {
              const { permissions } = permissionsContext
              if (
                !permissions.includes('control.settings.translation.edit') &&
                !permissions.includes('control-settings-translations')
              ) {
                return null
              }

              if (
                isCustomizing() &&
                (permissions.includes('control.appearance') || permissions.includes('control-appearance')) &&
                customizationPage
              ) {
                return <CustomizationToolbar page={customizationPage} controlUrl={controlUrl} elements={elements} />
              }

              return (
                <div className='translation--switch is-hidden-mobile-only'>
                  <a
                    href={controlUrl}
                    className={classNames('btn btn--S btn--insided-brand')}
                    target='_blank'
                    rel='noreferrer'
                  >
                    Control
                  </a>

                  {permissions.includes('control.appearance') || permissions.includes('control-appearance') ? (
                    <Configurator theme={getEnabledTheme()} />
                  ) : null}

                  {customizationPage &&
                  (permissions.includes('control.appearance') || permissions.includes('control-appearance')) ? (
                    <a
                      href='?customize'
                      data-track={JSON.stringify({ type: 'Destination Configuration Mode Activated' })}
                      className='btn--S btn--purple'
                    >
                      Customize
                    </a>
                  ) : null}

                  <div
                    className='translation--switch--container'
                    data-component='translation-switch'
                    data-data={JSON.stringify({
                      controlUrl: controlUrl,
                      canEditPhrases:
                        permissions.includes('control.settings.translation.edit') ||
                        permissions.includes('control-settings-translations'),
                      liveEdit: false // TODO: App.session.get('liveEdit')
                    })}
                  />
                  <Portal into='body'>
                    <TranslationForm liveEdit={false} />
                  </Portal>
                </div>
              )
            }}
          </UserPermissionContext.Consumer>
        )
      }}
    </CurrentUserContext.Consumer>
  )
}
export default AdminToolbar
